const routes = {
  path: '/volunteer',
  name: 'Volunteer',
  meta: {
    title: '巾帼志愿者管理',
    keepAlive: false
  },
  redirect: {
    name: 'Volunteer'
  },
  component: () => import('@/views/Layout/Main.vue'),
  children: [
    {
      path: 'volunteer/volunteer',
      name: 'VolunteerVolunteer',
      component: () => import('@/views/Pages/volunteer/volunteer'),
      meta: {
        title: '巾帼志愿者',
        keepAlive: false,
        isAuthRoute: true
      }
    },
    {
      path: 'volunteer/team',
      name: 'VolunteerTeam',
      component: () => import('@/views/Pages/volunteer/team'),
      meta: {
        title: '巾帼志愿者小组',
        keepAlive: false,
        isAuthRoute: true
      }
    },
    {
      path: 'volunteer/teamVolunteer/:teamId',
      name: 'VolunteerTeamVolunteer',
      component: () => import('@/views/Pages/volunteer/team/components/volunteer'),
      meta: {
        title: '小组成员',
        keepAlive: false,
        isAuthRoute: true
      }
    },
    {
      path: 'volunteer/goods',
      name: 'GoodsGoods',
      component: () => import('@/views/Pages/goods/goods'),
      meta: {
        title: '积分兑换管理',
        keepAlive: false,
        isAuthRoute: true
      }
    },
    {
      path: 'volunteer/goods/exchangeRecord/:goodsId',
      name: 'GoodsExchangeRecord',
      component: () => import('@/views/Pages/goods/goods/components/exchange'),
      meta: {
        title: '兑换记录',
        keepAlive: false,
        isAuthRoute: true
      }
    },
    {
      path: 'volunteer/exchange',
      name: 'GoodsExchange',
      component: () => import('@/views/Pages/goods/exchange'),
      meta: {
        title: '兑换记录',
        keepAlive: false,
        isAuthRoute: true
      }
    }
  ]
}

export default routes
